import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import HizmetlerPage from "../pages/hizmetler/page";
import ServiceDetailPage from "../pages/services/page";
import ProjelerPage from "../pages/projeler/page";
import DekorasyonPage from "../pages/dekorasyon/page";
import HakkimizdaPage from "../pages/hakkimizda/page";
import IletisimPage from "../pages/iletisim/page";
import ReferanslarPage from "../pages/referanslar/page";
import BlogPage from "../pages/blog/page";
import BlogDetailPage from "../pages/blog/detail";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/hizmetler",
    element: <HizmetlerPage />,
  },
  {
    path: "/hizmetler/:slug",
    element: <ServiceDetailPage />,
  },
  {
    path: "/projeler",
    element: <ProjelerPage />,
  },
  {
    path: "/dekorasyon",
    element: <DekorasyonPage />,
  },
  {
    path: "/referanslar",
    element: <ReferanslarPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetailPage />,
  },
  {
    path: "/hakkimizda",
    element: <HakkimizdaPage />,
  },
  {
    path: "/iletisim",
    element: <IletisimPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
